import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase';
import './VersionManager.css';

const VersionManager = () => {
    const [selectedPlatform, setSelectedPlatform] = useState('android'); // 'android' or 'ios'

    // Versions state
    const [androidVersion, setAndroidVersion] = useState({ major: 0, minor: 0, patch: 0 });
    const [iosVersion, setIosVersion] = useState({ major: 0, minor: 0, patch: 0 });

    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const getCollectionName = () => 'settings';

    const getDocId = (platform) => {
        // Trivia IDs
        return platform === 'android' ? 'CurrentVersion' : 'iosVersion';
    };

    // Field names mapping for Trivia
    const getFieldNames = () => {
        return { x: 'MajorVersion', y: 'MinorVersion', z: 'PatchVersion' };
    };

    const fetchVersions = async () => {
        setLoading(true);
        setMessage(null);
        try {
            // Fetch Android
            const androidDocRef = firestore.collection(getCollectionName()).doc(getDocId('android'));
            const androidSnap = await androidDocRef.get();

            // Fetch iOS
            const iosDocRef = firestore.collection(getCollectionName()).doc(getDocId('ios'));
            const iosSnap = await iosDocRef.get();

            const fields = getFieldNames();

            if (androidSnap.exists) {
                const data = androidSnap.data();
                setAndroidVersion({
                    major: data[fields.x] || 0,
                    minor: data[fields.y] || 0,
                    patch: data[fields.z] || 0
                });
            }

            if (iosSnap.exists) {
                const data = iosSnap.data();
                setIosVersion({
                    major: data[fields.x] || 0,
                    minor: data[fields.y] || 0,
                    patch: data[fields.z] || 0
                });
            }

        } catch (error) {
            console.error("Error fetching versions:", error);
            setMessage({ type: 'error', text: "Failed to fetch versions. " + error.message });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVersions();
    }, []);


    const handleSave = async (platform) => {
        setLoading(true);
        setMessage(null);
        try {
            const docId = getDocId(platform);
            const version = platform === 'android' ? androidVersion : iosVersion;
            const fields = getFieldNames();

            const updateData = {
                [fields.x]: parseInt(version.major),
                [fields.y]: parseInt(version.minor),
                [fields.z]: parseInt(version.patch)
            };

            await firestore.collection(getCollectionName()).doc(docId).set(updateData, { merge: true });
            setMessage({ type: 'success', text: `${platform.toUpperCase()} version updated successfully!` });

        } catch (error) {
            console.error("Error saving version:", error);
            setMessage({ type: 'error', text: "Failed to save version. " + error.message });
        } finally {
            setLoading(false);
        }
    };

    const currentVersion = selectedPlatform === 'android' ? androidVersion : iosVersion;
    const setVersion = selectedPlatform === 'android' ? setAndroidVersion : setIosVersion;

    return (
        <div className="version-manager-container card">
            <h2>App Version Control</h2>

            <div className="platform-selector">
                <button
                    className={selectedPlatform === 'android' ? 'active' : ''}
                    onClick={() => setSelectedPlatform('android')}>Android</button>
                <button
                    className={selectedPlatform === 'ios' ? 'active' : ''}
                    onClick={() => setSelectedPlatform('ios')}>iOS</button>
            </div>

            <div className="version-inputs">
                <h3>Trivia Israel - {selectedPlatform.toUpperCase()} Version</h3>

                <div className="input-group">
                    <label>Major (x)</label>
                    <input type="number" value={currentVersion.major} onChange={(e) => setVersion({ ...currentVersion, major: e.target.value })} />
                </div>
                <div className="input-group">
                    <label>Minor (y)</label>
                    <input type="number" value={currentVersion.minor} onChange={(e) => setVersion({ ...currentVersion, minor: e.target.value })} />
                </div>
                <div className="input-group">
                    <label>Patch (z)</label>
                    <input type="number" value={currentVersion.patch} onChange={(e) => setVersion({ ...currentVersion, patch: e.target.value })} />
                </div>

                <div className="actions">
                    <button onClick={() => handleSave(selectedPlatform)} disabled={loading} className="save-btn">
                        {loading ? 'Saving...' : 'Save Version'}
                    </button>
                </div>
            </div>

            {message && (
                <div className={`message ${message.type}`}>
                    {message.text}
                </div>
            )}
        </div>
    );
};

export default VersionManager;
